import {useAuthContext} from "../../auth/hooks";
import axiosInstance, {endpoints} from "../../lib/axios";
import {IOrganisation, ISkapaOrganisationRequest, IUppdateraOrganisationRequest, IRäkenskapsårFörOrganisation} from "../../types/nya/common";
import { toast } from "src/components/snackbar";


export function HämtaOrganisationerFörAnvändare(): Promise<IOrganisation[]> {
  return axiosInstance.get(endpoints.organisation.anvandare)
    .then(response => response.data);
}

/**
 * Slår upp en organisation hos Bolagsverket för att förifylla formuläret.
 * Query kan vara organisationsnummer (med eller utan bindestreck).
 */
export function VerifieraOrganisation(query: string): Promise<IOrganisation> {
  return axiosInstance.get(endpoints.organisation.verifiera, { params: { query } })
    .then(response => response.data);
}

/**
 * Skapar (registrerar) en ny organisation och kopplar nuvarande användare
 * som ORGANISATION_ADMIN. Returnerar den sparade organisationen.
 */
export function SkapaOrganisation(request: ISkapaOrganisationRequest): Promise<IOrganisation> {
  return axiosInstance.post(endpoints.organisation.root, request)
    .then(response => response.data);
}

/**
 * Uppdaterar redigerbara uppgifter för en organisation. Skickar orgId explicit i
 * X-Organisation-Id-huvudet så att det matchar sökvägen även om en annan organisation
 * är aktiv i app-kontexten.
 */
export function UppdateraOrganisation(
  orgId: string,
  request: IUppdateraOrganisationRequest
): Promise<IOrganisation> {
  return axiosInstance
    .put(endpoints.organisation.uppdatera(orgId), request, {
      headers: { 'X-Organisation-Id': orgId },
    })
    .then((response) => response.data);
}

// export function HämtaRäkenskapsÅrFörOrganisationer(organisationer: IOrganisation[]): Promise<IRäkenskapsårFörOrganisation[]> {
//   const orgIdn = organisationer.map(organisation => organisation.id);
//   const body = {
//     orgIdn
//   };
//
//   return axiosInstance.post(endpoints.organisation.rakenskapsar.root, body)
//     .then(response => response.data)
//     .catch(error => toast.error(error));
// }

//     .then(response => response.data)
//     .catch(error => Promise.resolve({
//         orgId: null,
//         apiResultat: {
//           meddelande: 'Ett fel uppstod under parsningen: ' + error.message,
//           framgångsRikt: false,
//         },
//         kundfaktura: undefined
//       })
//     );
// }
// }
//
// export function parsaKundfaktura(file: File):
//   const formData = new FormData();
//   formData.append('kundfaktura', file);
//   const orgid = 'f0cc3e44-1858-4849-96ee-e4c64af36ca2';
//   // Replace 'http://your-server.com/upload' with your actual server endpoint
//

